import React, { useContext } from "react";
import { Title as DialogPrimitiveTitle } from "@radix-ui/react-dialog";
import PropTypes from "prop-types";
import cc from "classcat";
import { Helmet } from "react-helmet-async";
import { twMerge } from "tailwind-merge";
import { ModalContext } from "./Modal";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
ModalTitle.propTypes = {
    children: PropTypes.node.isRequired,
    visuallyHidden: PropTypes.bool
};
export default function ModalTitle(param) {
    var children = param.children, _param_visuallyHidden = param.visuallyHidden, visuallyHidden = _param_visuallyHidden === void 0 ? false : _param_visuallyHidden;
    var centered = useContext(ModalContext).centered;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Helmet, null, /*#__PURE__*/ React.createElement("title", null, children)), /*#__PURE__*/ React.createElement(DialogPrimitiveTitle, {
        className: twMerge(cc([
            "w-full px-8 pb-2 text-center text-2xl font-semibold text-black dark:border-gray-700 dark:text-gray-200",
            {
                "flex items-center justify-center md:pt-6": centered
            },
            {
                "mb-5 pb-5 md:pt-0 md:text-start": !centered
            }
        ]))
    }, visuallyHidden ? /*#__PURE__*/ React.createElement(VisuallyHidden, {
        asChild: false
    }, children) : children));
}
